<template>
  <div>
    <SelectSingleField
        label="Город получения"
        :choices="citiesChoices"
        v-model="selectedValue"
        :placeholder="'Выберите город'"
    />

    <ThePickupPoints
        v-if="selectedValue"
        :points="points"
    />
  </div>
</template>

<script>
import SelectSingleField from "../../filter/field/SelectSingleField.vue";
import pickupPointsService from "../../services/pickupPoints.service";
import cartService from "../../services/cart.service";
import ThePickupPoints from "./ThePickupPoints.vue";

export default {
  name: "TheDeliveryPoints",
  components: {
    SelectSingleField,
    ThePickupPoints
  },
  computed: {
    deliveryCompany: {
      get () {
        return this.$store.state.order.deliveryCompany;
      },
      set (value) {
        this.$store.commit('order/setDeliveryCompany',  parseInt(value, 10))
      }
    },
  },
  data() {
    return {
      selectedValue: null,
      points: [],
      citiesChoices: [],
      ymapInstance: null,
    };
  },
  watch: {
    // Следим за изменениями в ТК - сбрасываем город и карту, фетчим города
    deliveryCompany(val) {
      this.fetchCities(val)
      this.selectedValue = null;
      this.clearMap();
    },
    // При выборе города - фетчим точки выдачи
    selectedValue(newValue) {
      this.$store.commit('order/setDeliveryCompanyPoint', null);
      this.$store.commit('order/setParcelShop',  null);
      this.fetchPointsForCity();
    },
  },
  methods: {
    // Фетчим города для тк
    async fetchCities(tk) {
      try {
        const response = await cartService.loadCities(tk);
        const data = response.data;
        this.citiesChoices = this.formattedCities(data);
      } catch (error) {
        console.error("Error fetching points:", error);
      }
    },
    formattedCities(data) {
      return data.map((city) => ({
        key: city.cityId,
        label: city.city,
      }));
    },
    // Фетч точек
    async fetchPointsForCity() {
      try {
        const response = await pickupPointsService.fetchPointsByCity(this.selectedValue);
        const data = response.data;
        if (!Array.isArray(data)) {
          console.error("Error: Expected an array but got:", response);
          return;
        }
        this.points = data.map((p) => ({
          id: p.id,
          code: p.code,
          city: p.city,
          cityId: p.cityId,
          deliveryAgent: p.deliveryAgent,
          addressLat: p.lat,
          addressLng: p.lng,
          address: p.address,
          schedule: p.schedule
        }));
        this.initializePickupPointsMap();
      } catch (error) {
        console.error("Error fetching points:", error);
      }
    },
    // Инит карты
    initializePickupPointsMap() {
      this.clearMap();
      this.element = document.querySelector('[data-cart-map]')
      document.dispatchEvent(new CustomEvent('pickupPoint:map:init', {
        detail: {
          points: this.points,
          element: this.element
        }
      }))
    },
    // Дестрой карты
    clearMap() {
      document.dispatchEvent(
          new CustomEvent("pickupPoint:map:destroy")
      )
    },
    scrollListToView(event) {
      const targetElement = document.querySelector(`[data-pont-id="${event.detail.id}"]`);
      const listElement = document.querySelector('[data-points-list]');


      if (!targetElement || !listElement) {
        console.error("Invalid listItemElement or listElement.");
        return;
      }

      const targetRect = targetElement.getBoundingClientRect();
      const listRect = listElement.getBoundingClientRect();

      const offsetTop = targetRect.top - listRect.top + listElement.scrollTop;

      listElement.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });


      targetElement.querySelector('input').click();
    }
  },
  // На маунтед тоже фетчим - изменения при первом маунте мы не отслеживаем еще
  mounted() {
    this.fetchCities(this.deliveryCompany)
    document.addEventListener('pickupPoint:map:placemark:click', (e) => {
      this.scrollListToView(e);
    });
  }
};
</script>
